import type { TraceErrorObject } from 'owa-trace';

export interface OwsError extends Error {
    isTransformError?: boolean;
    serviceFetchError?: TraceErrorObject;
    response?: Response;
    responseCode?: string;
}

export function createOwsError(error: {
    name: string;
    message: string;
    serviceFetchError?: TraceErrorObject;
    isTransformError?: boolean;
    response?: Response;
    responseCode?: string;
}): OwsError {
    return {
        ...error,
    };
}
